import moment from 'moment';
import _ from 'lodash';

export const clienteInitialValues = {
  partitaiva: '',
  tipoValidazione: 'reddituale',
  reddito_id: '',
  reddito_tipoValidazione: 'reddituale', // Inizio reddito
  reddito_occupazione: '',
  reddito_professione: '',
  reddito_partitaivaDatorelavoro: '',
  reddito_pecDatorelavoro: '',
  reddito_nomeDatorelavoro: '',
  reddito_tfrMaturato: '',
  reddito_redditoMensileNetto: '',
  reddito_redditoAnnuoNetto: '',
  reddito_numeroMensilita: 0,
  reddito_dataAssunzione: '',
  reddito_numeroFamiliariCarico: 0, // Fine reddito
  debiti: [],
  debitiInCorso: 'false',
  protestiSofferenze: 'false',
};

export const mapToClienteInitialValues = (newValues) => {
  const mappedValues = {
    id: newValues.id || '',
    partitaiva: newValues.partitaiva || '',
    tipoValidazione: newValues.tipoValidazione || 'reddituale',
    reddito_id: _.get(newValues, '_embedded.reddito.id') ? newValues._embedded.reddito.id : '', // eslint-disable-line
    reddito_tipoValidazione: newValues.tipoValidazione || 'reddituale', // Inizio reddito
    reddito_occupazione: _.get(newValues, '_embedded.reddito._embedded.occupazione') ? { label: newValues._embedded.reddito._embedded.occupazione.nome, value: newValues._embedded.reddito._embedded.occupazione.id } : '', // eslint-disable-line
    reddito_professione: _.get(newValues, '_embedded.reddito._embedded.professione') ? newValues._embedded.reddito._embedded.professione.id : '', // eslint-disable-line
    reddito_tipologiaDatorelavoro: _.get(newValues, '_embedded.reddito.tipologiaDatorelavoro') ? _.get(newValues, '_embedded.reddito.tipologiaDatorelavoro') : '', // eslint-disable-line
    reddito_partitaivaDatorelavoro: _.get(newValues, '_embedded.reddito.partitaivaDatorelavoro') ? newValues._embedded.reddito.partitaivaDatorelavoro : '', // eslint-disable-line
    reddito_pecDatorelavoro: _.get(newValues, '_embedded.reddito.pecDatorelavoro') ? newValues._embedded.reddito.pecDatorelavoro : '', // eslint-disable-line
    reddito_nomeDatorelavoro: _.get(newValues, '_embedded.reddito.nomeDatorelavoro') ? (newValues._embedded.reddito.nomeDatorelavoro || '') : '', // eslint-disable-line
    reddito_tfrMaturato: _.get(newValues, '_embedded.reddito.tfrMaturato') ? newValues._embedded.reddito.tfrMaturato : '', // eslint-disable-line
    reddito_redditoMensileNetto: _.get(newValues, '_embedded.reddito.redditoMensileNetto') ? newValues._embedded.reddito.redditoMensileNetto : '', // eslint-disable-line
    reddito_redditoAnnuoNetto: _.get(newValues, '_embedded.reddito.redditoAnnuoNetto') ? newValues._embedded.reddito.redditoAnnuoNetto : '', // eslint-disable-line
    reddito_numeroMensilita: _.get(newValues, '_embedded.reddito.numeroMensilita') ? newValues._embedded.reddito.numeroMensilita : '', // eslint-disable-line
    reddito_dataAssunzione: _.get(newValues, '_embedded.reddito.dataAssunzione') ? moment.unix(newValues._embedded.reddito.dataAssunzione) : '', // eslint-disable-line
    reddito_numeroFamiliariCarico: _.get(newValues, '_embedded.reddito') ? newValues._embedded.reddito.numeroFamiliariCarico : '', // eslint-disable-line
    debiti: _.get(newValues, '_embedded.debiti') ? newValues._embedded.debiti.map((debito) => ({ scadenza: debito.dataScadenza ? moment.unix(debito.dataScadenza) : '', importo: debito.importoRata, istituto: debito.istituto, id: debito.id })) : [], // eslint-disable-line
    debitiInCorso: _.get(newValues, '_embedded.debiti').length ? 'true' : 'false', // eslint-disable-line
    protestiSofferenze: newValues.protestiSofferenze || 'false',
  };

  return mappedValues;
};

export default clienteInitialValues;



// WEBPACK FOOTER //
// ./app/components/Forms/Anagrafica/Cliente/initialValues.js